import React from 'react';

import Layout from '@/components/layout/LayoutWrapper';
import ShippingTermsAndReturnPolicy from '@/components/ShippingTermsAndReturnPolicy';

const ShippingTermsAndReturnPolicyPage = () => (
	<Layout pageName="shipping-terms-and-return-policy" title="Calm - Shipping Terms and Return Policy">
		<ShippingTermsAndReturnPolicy />
	</Layout>
);

export { getServerSideProps } from '@/utils/pageGeneration/getServerSideProps';

export default ShippingTermsAndReturnPolicyPage;
